module.exports = __webpack_public_path__ + "img/home-image.ac5c511d.jpg";